// extracted by mini-css-extract-plugin
export default {"sidebar":"index_sidebar__AzaUQ","iconContainer":"index_iconContainer__pvQyu","iconSVG":"index_iconSVG__eGFMu"};